import React from "react";
import http from "../../util/api";
import qs from "qs";
import moment from "moment";
import "./PatientShowContent.scss";
import img0 from "./imgs/logo1.jpg";
import img1 from "./imgs/SHVO.png";
import img2 from "./imgs/logo1.png";
import { Toast, Button } from "antd-mobile";
import SignatureCanvas from "react-signature-canvas";
import BraftEditor from "braft-editor";
import "braft-editor/dist/index.css";

let timer;
class PatientShowContent extends React.Component {
  state = {
    title: "",
    toWrite: "",
    signature: null,
    REC_ID: "",
    showSigPad: false,
    trimmedDataURL: "",
    h: window.innerHeight,
    w: window.innerWidth - 48,
    name: "",
    fund: "",
    stTime: "",
    edTime: "",
    theme: "",
    speech: "",
    job: "",
    service: "",
    cost: "",
    id: "",
    BC: "",
    date: "",
    check1: false,
    check2: false,
    check3: false,
    check4: false,
    canSub: false,
    editorState: "",
  };

  async componentDidMount() {
    const search = document.location.search;
    const querystring = search.substring(1);
    let name = qs.parse(querystring).name; //从url中取id
    let telephone = qs.parse(querystring).telephone; //从url中取id
    Toast.loading("登录中，请稍后…");
    this.getToken();
    let myDateS = new Date();
    myDateS = moment(myDateS).format("YYYY-MM-DD");
    this.setState({ date: myDateS });
    this.getRec(name, telephone);
    }
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.trim = this.trim.bind(this);
  }

  submitContent = async () => {
    const htmlContent = this.state.editorState.toHTML();
  };

  handleEditorChange = (editorState) => {
    this.setState({ editorState });
  };

  sigCanvas = {
    clear: () => {},
    toDataURL: (param) => {
      return "";
    },
  };
  clear() {
    this.sigCanvas.clear();
    this.setState({ signature: null, trimmedDataURL: "" });
  }
  trim() {
    this.setState({
      showSigPad: false,
      signature: this.sigCanvas.toDataURL("image/png"),
      trimmedDataURL: this.sigCanvas.toDataURL("image/png"),
    });
  }
  getToken = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
      // await this.addRec();
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };
  getRec = async (name, telephone) => {
    Toast.loading("获取数据中", 0);
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).getTable({
        resid: 644680002327,
        cmswhere: `name = '${name}' and telephone = '${telephone}'`,
      });
      if (res.data.data[0].base64Picture) {
        this.setState({
          canSub: true,
          check1: true,
          check2: true,
          check3: true,
          check4: true,
        });
      } else {
        this.setState({ canSub: false });
      }
      this.setState({
        name: res.data.data[0].name,
        fund: res.data.data[0].client,
        stTime: res.data.data[0].starttime,
        edTime: res.data.data[0].endtime,
        theme: res.data.data[0].event_topic,
        speech: res.data.data[0].speech_topic,
        job: res.data.data[0].service_name,
        service: res.data.data[0].service_type,
        cost: res.data.data[0].amount,
        id: res.data.data[0].ID,
        BC: res.data.data[0].bank_count,
        date: res.data.data[0].signature_time,
        signature: res.data.data[0].base64Picture,
        trimmedDataURL: res.data.data[0].base64Picture,
        REC_ID: res.data.data[0].REC_ID,
      });

      this.setState({
        editorState: BraftEditor.createEditorState(res.data.data[0].words),
      });
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("数据获取失败");
    }
  };

  //将base64转换为blob
  dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  //将blob转换为file
  blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };
  //调用

  submit = async () => {
    let url = { baseURL: window.liveUrl };
    if (this.state.signature) {
      Toast.loading("正在提交");
      let myDate = new Date();
      myDate = moment(myDate).format("YYYY-MM-DD");
      let obj = {
        REC_ID: this.state.REC_ID,
        base64Picture: this.state.signature,
        //   name:'张三',
        //   client:'1000',
        //   starttime:'20200506',
        //   endtime:'20200509',
        //   event_topic:'禽类营养讲座',
        //   speech_topic:'鸡汤应该在餐前喝还是餐后喝',
        //   service_name:'厨师',
        //   service_type:'烹饪午餐',
        //   amount:'200',
        //  ID:'32019800808044X',
        //  bank_count:'1234567890ab',
        signature_time: myDate,
      };
      let res2 = await http(url).modifyRecords({
        resid: 644680002327,
        data: [obj],
      });
      this.setState({ canSub: false });
      Toast.success("提交成功");
    } else {
      Toast.fail("您还没有签名");
    }
    // else {
    //   Toast.fail("请勾选所有服务和工作内容！");
    // }
  };

  handleChange = (editorState) => {
    this.setState({ editorState, outputHTML: editorState.toHTML() });
  };
  render() {
    let { trimmedDataURL, editorState } = this.state;
    const excludeControls = [
      "letter-spacing",
      "line-height",
      "clear",
      "headings",
      "list-ol",
      "list-ul",
      "remove-styles",
      "superscript",
      "subscript",
      "hr",
      "text-align",
    ];
    const controls = [];
    // const controls = ['bold', 'italic', 'underline', 'separator']
    const extendControls = [
      {
        key: "custom-button",
        type: "button",
        text: "预览",
        onClick: this.preview,
      },
    ];

    return (
      <div className="content_sig">

        <BraftEditor
          onChange={this.handleChange}
          controls={controls}
          readOnly={true}
          value={editorState}
          contentStyle={{ height: "100%" }}
        />
        <p>签名：</p>
        {!this.state.signature ? (
          <>
            <div
              className="blank"
              onClick={() => {
                this.setState({ showSigPad: true });
              }}
            >
              点击开始签名
            </div>
          </>
        ) : (
          <>
            <img
              ref="img"
              style={{ maxHeight: "calc(100vh - 14rem)" }}
              onClick={() => {
                if (!this.state.canSub) {
                  this.setState({ showSigPad: true });
                }
              }}
              src={this.state.signature}
            />
          </>
        )}
        <div className="btnLine">
          {!this.state.canSub ? (
            <Button
              type="primary"
              className="submit"
              onClick={() => {
                this.submit();
              }}
            >
              提交
            </Button>
          ) : null}
        </div>
        <div className={this.state.showSigPad ? "sigPad" : "hidden"}>
          <div className="titleLine">
            <Button
              size="small"
              type="primary"
              onClick={() => {
                this.trim();
              }}
            >
              确定
            </Button>
            <Button
              size="small"
              onClick={() => {
                this.setState({ showSigPad: false });
              }}
            >
              取消
            </Button>
            <Button
              size="small"
              style={{ float: "left" }}
              onClick={() => {
                this.clear();
              }}
            >
              清空
            </Button>
          </div>
          <div className="paper">
            <SignatureCanvas
              penColor="green"
              canvasProps={{
                width: this.state.w,
                height: this.state.h,
                className: "sigCanvas",
              }}
              ref={(ref) => {
                this.sigCanvas = ref;
              }}
            />
          </div>
        </div>
        <div className="imgLine">

        <img src={img0} />
          <img src={img1} />
          <img src={img2} />
        </div>
      </div>
    );
  }
}

export default PatientShowContent;
